import { IAddressInputModel } from 'inputModels';

export const handleGetAddressError = (input: IAddressInputModel | undefined) => {
  if (!input || (!input.city && !input.street && !input.postalCode))
    return { hasError: true, message: 'Endereço é obrigatório' };

  if (!input.postalCode)
    return { hasError: true, message: 'O endereço fornecido não contém um CEP' };

  if (!input.city) return { hasError: true, message: 'O endereço fornecido não contém uma Cidade' };

  if (!input.street) return { hasError: true, message: 'O endereço fornecido não contém uma Rua' };

  // number === 0 é válido (S/N, sem número)
  if (input.number === undefined)
    return { hasError: true, message: 'O endereço fornecido não contém um Número' };
  return { hasError: false, message: '' };
};
